module.exports = __webpack_public_path__ + "img/image50.879f9ff7.webp";